<script setup lang="ts">
import { useTenantStore } from '@/stores/tenant'

withDefaults(defineProps<{ size?: 'md' | 'lg' }>(), { size: 'md' })

const tenant = useTenantStore()
</script>

<template>
  <div class="flex items-center px-2 py-1">
    <img
      v-if="tenant.branding.logoUrl"
      :src="tenant.branding.logoUrl"
      :alt="tenant.branding.appName"
      :class="size === 'lg' ? 'h-7' : 'h-6'"
      class="w-auto"
    />
    <span
      v-else
      :class="size === 'lg' ? 'text-2xl' : 'text-xl'"
      class="text-primary font-bold lowercase"
      >moose</span
    >
  </div>
</template>
